import React from "react";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Elif Y.",
    role: "Lazer Epilasyon",
    text: "İlk seansta sıcakkanlı yaklaşımları ve profesyonelliği ile rahat ettim. Sonuçlar gerçekten beklediğimden çok daha iyi oldu.",
  },
  {
    name: "Merve K.",
    role: "Saten Yüz Germe",
    text: "Çene hattımdaki belirginleşme inanılmaz. Ameliyatsız bu sonucu beklemiyordum. İONA ekibine çok teşekkür ederim.",
  },
  {
    name: "Sevgi A.",
    role: "Cilt Bakımı",
    text: "3D analiz sonrası önerilen protokol cildime çok iyi geldi. Ortam ferah, hijyenik ve gerçekten premium bir hizmet.",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="iona-section bg-white">
      <div className="iona-container">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-[#5E2A84] mb-4">
            — Müşteri Yorumları
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] leading-[1.1] tracking-tight">
            Onlar da İONA'yı <span className="italic text-[#5E2A84]">tercih etti</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="relative bg-[#F8F9FA] border border-[#F0F0F0] rounded-3xl p-8 iona-hover-lift"
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-[#E8E2F0]" strokeWidth={1.5} />
              <div className="flex gap-0.5 mb-5">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#5E2A84] text-[#5E2A84]" />
                ))}
              </div>
              <p className="text-[#1A1A1A] leading-relaxed mb-7">"{t.text}"</p>
              <div>
                <div className="font-serif text-lg text-[#1A1A1A]">{t.name}</div>
                <div className="text-xs uppercase tracking-wider text-[#5E2A84]">
                  {t.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
